module.exports = __webpack_public_path__ + "static/apple-touch-icon-144x144-6e4de7f70f1e52c97b2a902a2e28e4e4.png";